// extracted by mini-css-extract-plugin
export default {"actions":"Button_actions__grEBt","actions2":"Button_actions2__kewdh"};